import { render } from "./AquaparkReviews.vue?vue&type=template&id=53e30d4b"
import script from "./AquaparkReviews.vue?vue&type=script&lang=js"
export * from "./AquaparkReviews.vue?vue&type=script&lang=js"

import "./AquaparkReviews.vue?vue&type=style&index=0&id=53e30d4b&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__